<template>
  <el-dialog
    :visible.sync="updateDV"
    width="400px"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <div class="title">修改密码</div>
    <el-form
      ref="retrieveForm"
      :model="retrieveForm"
      class="register-form"
      :rules="retrieveRules"
    >
      <el-form-item>
        <el-input
          v-model="retrieveForm.email"
          placeholder="邮箱"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="retrieveForm.password"
          placeholder="设置6～16位密码，区分大小写"
          type="password"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="retrieveForm.confirmPassword"
          placeholder="确认密码"
          type="password"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-btn">
      <el-button @click="handleSubmit">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { forgot } from '@/api/user.js'
export default {
  name: 'UpdatePassword',
  components: {},
  props: {},
  data() {
    let RedPsd = /^(?=.*[a-zA-Z\d])[!-~]{6,16}$/;
    let validatePassword = (rule, val, callback) => {
      if (val === '') {
        callback(new Error('请输入密码'));
      } else if (!RedPsd.test(val)) {
        callback(new Error('密码格式不正确'));
      } else {
        callback();
      }
    };
    let validateConfirmPassword = (rule, val, callback) => {
      if (val === '') {
        callback(new Error('请输入密码'));
      } else if (this.registerForm.password !== val) {
        callback(new Error('两次密码输入不一致,请重新输入'));
      } else {
        callback();
      }
    };
    return {
      updateDV: true,
      retrieveForm: {
        email: '',
        password: '',
        confirmPassword: '',
        code: ''
      },
      retrieveRules: {
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    this.retrieveForm.email = this.$route.query.email
    this.retrieveForm.code = this.$route.query.code
  },
  methods: {
    handleSubmit() {
      this.$refs['retrieveForm'].validate(async (valid) => {
        if (valid) {
          let res = await forgot(this.retrieveForm)
          if (res.success) {
            this.$message.success('修改成功')
            this.$router.replace('/home')
          }
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.el-dialog {
  .title {
    text-align: center;
    font-size: 24px;
    font-weight: 400;
    color: #24232f;
    margin-bottom: 18px;
  }
  .submit-btn {
    display: flex;
    justify-content: center;
    .el-button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 180px;
      height: 50px;
      background: linear-gradient(-64deg, #2f65ff, #4e84ff);
      color: #fff;
      font-weight: 400;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
</style>
